// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__19eZa","buttons":"SendReceipts_buttons__EdzTf","email":"SendReceipts_email__1-wAN","bookApptTitle":"SendReceipts_bookApptTitle__3-dbW"};